// extracted by mini-css-extract-plugin
module.exports = {"w1000":"w1000-1qAGSt91","arl_m_tit":"arl_m_tit-1hNkmEnU","arl_subnav":"arl_subnav-1HkZNK7R","on":"on-12UWLvL_","serial_tuan":"serial_tuan-dOlfo_7M"};